import { format } from 'date-fns';

import { type CenterSlotProps } from './CenterSlot';
import { type LeftSlotProps } from './LeftSlot';
import { type RightSlotProps } from './RightSlot';
import { isUnlockDateSlot } from './RightSlot/helpers';

export interface AssignedProgramContentCardSlots {
  centerSlot?: CenterSlotProps;
  leftSlot?: LeftSlotProps;
  rightSlot?: RightSlotProps;
}

/**
 * Returns a tooltip text indicating when the level will be available based on the unlock date of
 * the right slot.
 *
 * @param {RightSlotProps | undefined} slots
 *   The props for the right slot that contains program content information.
 *
 * @returns {string | null} The tooltip text with the availability information.
 */
export const getTooltipText = (rightSlot?: RightSlotProps): null | string => {
  if (rightSlot && isUnlockDateSlot(rightSlot) && rightSlot.unlockDate) {
    const formattedUnlockDate = format(rightSlot.unlockDate, 'MMM. dd, yyyy');
    return (
      'This level is locked by your admin. It will become available on ' + `${formattedUnlockDate}.`
    );
  }
  return null;
};
